import _extends from 'babel-runtime/helpers/extends';

import { devices } from '@/views/creative/utils/device-info';
import PreviewLanguageSelector from './preview-language-selector.vue';
import OrientationOptions from '@com/components/orientation-selector';

export default {
  components: {
    PreviewLanguageSelector: PreviewLanguageSelector,
    OrientationOptions: OrientationOptions
  },
  props: {
    condition: {
      type: Object,
      required: true,
      default: function _default() {
        return {
          orientation: 2,
          deviceType: 3
        };
      }
    },
    deviceSelect: {
      type: Boolean,
      default: true
    },
    languageSelect: {
      type: Boolean,
      default: false
    },
    orientationSize: {
      type: String,
      default: 'medium'
    }
  },

  data: function data() {
    return {
      deviceOptions: [{
        label: this.$t('playTurbo.custom.previewer.selectDevice'),
        options: devices
      }],
      fallbackLocale: ''
    };
  },


  computed: {
    deviceType: {
      get: function get() {
        return this.condition.deviceType;
      },
      set: function set(val) {
        this.updateCondition({
          deviceType: val
        });
      }
    }
  },

  methods: {
    updateCondition: function updateCondition(value) {
      this.$emit('update:condition', _extends({}, this.condition, value));
    }
  }
};